import { createSvgIcon } from '@mui/material';
// or with custom SVG
export const RecgtangleIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth={1}
  >
    <g filter="url(#filter0_d_6658_6289)">
      <rect x="1.5" y="1.5" width="15" height="15" rx="4" fill="white" />
    </g>
  </svg>,
  "Rectangle",
);

export default RecgtangleIcon;
